export default __webpack_public_path__ + "static/media/GliderGolfScreenshot.f68b48f7.jpg";